import { render } from "./MetadataListPanel.vue?vue&type=template&id=66119430&scoped=true"
import script from "./MetadataListPanel.vue?vue&type=script&lang=js"
export * from "./MetadataListPanel.vue?vue&type=script&lang=js"

import "./MetadataListPanel.vue?vue&type=style&index=0&id=66119430&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66119430"]])

export default __exports__